import React, { useState } from 'react';
import './Tabs.css';

const Tabs = ({ tabs }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="custom-tabs-container">
      <div className="custom-tab-headers">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`custom-tab-button ${activeIndex === index ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="custom-tab-content">
        {tabs[activeIndex].content}
      </div>
    </div>
  );
};

export default Tabs;